import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const recommendationFields: FieldInterface[] = [
  {
    key: 'formatedData',
    originKey: 'formated_data',
    type: FIELD_TYPES.object,
  },
]

const recommendationRelations: RelationInterface[] = []

export { recommendationFields, recommendationRelations }
